function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M504,304H344v-16h8c4.418,0,8-3.582,8-8s-3.582-8-8-8h-8v-8c0-17.673,14.327-32,32-32c17.673,0,32,14.327,32,32 c0,4.418,3.582,8,8,8s8-3.582,8-8c0-26.51-21.49-48-48-48c-26.51,0-48,21.49-48,48v40H193.76c3.995-4.373,6.219-10.077,6.24-16 v-48c0-4.418-3.582-8-8-8H72c-4.418,0-8,3.582-8,8v48c0.021,5.923,2.245,11.627,6.24,16H8c-4.418,0-8,3.582-8,8v192 c0,4.418,3.582,8,8,8h496c4.418,0,8-3.582,8-8V312C512,307.582,508.418,304,504,304z M80,248h104v40c0,4.418-3.582,8-8,8H88 c-4.418,0-8-3.582-8-8V248z M128,496H16v-96h112V496z M128,384H16v-64h24c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8h24V384z  M368,496H144V320h224V496z M496,496H384v-96h112V496z M496,384H384v-64h24c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8h24V384z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160,440h192c4.418,0,8-3.582,8-8v-80c0-4.418-3.582-8-8-8H160c-4.418,0-8,3.582-8,8v80C152,436.418,155.582,440,160,440 z M168,360h176v64H168V360z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304,464h-96c-4.418,0-8,3.582-8,8s3.582,8,8,8h96c4.418,0,8-3.582,8-8S308.418,464,304,464z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88,120h336c4.418,0,8-3.582,8-8V8c0-4.418-3.582-8-8-8H88c-4.418,0-8,3.582-8,8v104C80,116.418,83.582,120,88,120z  M264,16h152v88H264V16z M96,16h152v88H96V16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200,56h-64c-4.418,0-8,3.582-8,8s3.582,8,8,8h64c4.418,0,8-3.582,8-8S204.418,56,200,56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376,56h-64c-4.418,0-8,3.582-8,8s3.582,8,8,8h64c4.418,0,8-3.582,8-8S380.418,56,376,56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.2,197.6c-6.631,3.818-10.854,10.756-11.2,18.4c0,4.418,3.582,8,8,8s8-3.582,8-8c0-1.688,0.8-2.576,4.8-5.6 c6.631-3.818,10.854-10.756,11.2-18.4c-0.346-7.644-4.569-14.582-11.2-18.4c-4.04-3.032-4.8-3.92-4.8-5.6s0.8-2.56,4.8-5.6 c6.631-3.818,10.854-10.756,11.2-18.4c0-4.418-3.582-8-8-8s-8,3.582-8,8c0,1.672-0.8,2.56-4.8,5.6 c-6.631,3.818-10.854,10.756-11.2,18.4c0.346,7.644,4.569,14.582,11.2,18.4c4,3.032,4.8,3.92,4.8,5.6S95.2,194.56,91.2,197.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.8,162.4c6.631-3.818,10.854-10.756,11.2-18.4c0-4.418-3.582-8-8-8s-8,3.582-8,8c0,1.672-0.8,2.56-4.8,5.6 c-6.631,3.818-10.854,10.756-11.2,18.4c0.346,7.644,4.569,14.582,11.2,18.4c4,3.032,4.8,3.92,4.8,5.6s-0.8,2.576-4.8,5.6 c-6.631,3.818-10.854,10.756-11.2,18.4c0,4.418,3.582,8,8,8s8-3.582,8-8c0-1.688,0.8-2.576,4.8-5.6 c6.631-3.818,10.854-10.756,11.2-18.4c-0.346-7.644-4.569-14.582-11.2-18.4c-4-3.032-4.8-3.92-4.8-5.6S136.8,165.416,140.8,162.4 z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.8,162.4c6.631-3.818,10.854-10.756,11.2-18.4c0-4.418-3.582-8-8-8s-8,3.582-8,8c0,1.672-0.8,2.56-4.8,5.6 c-6.631,3.818-10.854,10.756-11.2,18.4c0.346,7.644,4.569,14.582,11.2,18.4c4,3.032,4.8,3.92,4.8,5.6s-0.8,2.576-4.8,5.6 c-6.631,3.818-10.854,10.756-11.2,18.4c0,4.418,3.582,8,8,8s8-3.582,8-8c0-1.688,0.8-2.576,4.8-5.6 c6.631-3.818,10.854-10.756,11.2-18.4c-0.346-7.644-4.569-14.582-11.2-18.4c-4-3.032-4.8-3.92-4.8-5.6S176.8,165.416,180.8,162.4 z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgKitchen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.77661567.svg";
export { ForwardRef as ReactComponent };